import { render, staticRenderFns } from "./SwordFooter.vue?vue&type=template&id=a1e509b0&scoped=true&"
import script from "./SwordFooter.vue?vue&type=script&lang=js&"
export * from "./SwordFooter.vue?vue&type=script&lang=js&"
import style0 from "./SwordFooter.vue?vue&type=style&index=0&id=a1e509b0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1e509b0",
  null
  
)

export default component.exports